import cookie from "react-cookies";
import i18next from "i18next";
import { goLogin } from "helpers";
import store from "store";
import { POST } from "constant/method";
import { FORM_CONTENT_TYPE, ROOT_URL } from "./config";
import { handleFetchErrors, handleFailedToFetch } from "../helpers";
import { toastr } from "../components/toastr";

export const PIN_LIST = "PIN_LIST";
export const SET_PIN_LIST = "SET_PIN_LIST";
export const ADD_TO_PIN_LIST = "ADD_TO_PIN_LIST";
export const DEL_ITEM_PIN_LIST = "DEL_ITEM_PIN_LIST";

export function setPinList(newList) {
    return (dispatch) => {
        dispatch({
            type: SET_PIN_LIST,
            newList
        })
    }
}

export function addToPinList(newItem) {
    return (dispatch) => {
        dispatch({
            type: ADD_TO_PIN_LIST,
            newItem
        })
    }
}

export function delItemOnPinList(item) {
    return (dispatch) => {
        dispatch({
            type: DEL_ITEM_PIN_LIST,
            item
        })
    }
}

export const addPinVod = async (titleNo, type = "VOD") => {
	const { is_login } = store.getState().authenticationReducer;

	if (!is_login) {
		if (window.confirm(i18next.t("Đăng nhập để thự hiện chức năng"))) {
			goLogin();
		}
		return;
	}
	const { pinList } = store.getState().pinListReducer;

    let typeVod = window.location.href.substring(window.location.href.lastIndexOf('/') + 1);
	let idx = typeVod.indexOf("?");
	if (idx > 0) {
		typeVod = typeVod.slice(0, idx)
	}
	if (typeVod == 'vods') {
		typeVod = 'all';
	}

	const res =  fetch(`${ROOT_URL}/${global.bj_id}/priority/pin`, {
					method: POST,
					body: JSON.stringify({
                        broad_list: [...pinList],
                        type: typeVod,
                        _token: cookie.load("XSRF-TOKEN"),
                        _method: POST 
                    }),
					headers: {
                        "Content-Type": "application/json",
                      },
					credentials: "include",
				}).then(handleFetchErrors, handleFailedToFetch)
				.then((response) => response.json())
				.then((response) => {
					toastr.success(i18next.t(response.message), {
						timeOut: 2000,
					});
				})
				.catch((error) => {
					toastr.error(error.message, {
						timeOut: 2000,
					});
				});
};

